import * as React from "react";

const CENCartTrash: React.FC = () => {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M6.53438 1.5H9.4625C9.54688 1.5 9.625 1.54062 9.67188 1.6125L10.2656 2.5H5.73438L6.32812 1.6125C6.375 1.54375 6.45312 1.5 6.5375 1.5H6.53438ZM12.0688 2.5L10.9219 0.778125C10.5969 0.29375 10.05 0 9.46562 0H6.53438C5.95 0 5.40312 0.29375 5.07812 0.778125L3.93125 2.5H3.50312H2H1.75C1.33437 2.5 1 2.83437 1 3.25C1 3.66563 1.33437 4 1.75 4H2.1125L2.8625 14.1469C2.94062 15.1906 3.80938 16 4.85625 16H11.1406C12.1875 16 13.0562 15.1906 13.1344 14.1469L13.8875 4H14.25C14.6656 4 15 3.66563 15 3.25C15 2.83437 14.6656 2.5 14.25 2.5H14H12.4969H12.0688ZM12.3844 4L11.6406 14.0375C11.6219 14.3 11.4031 14.5 11.1406 14.5H4.85625C4.59375 14.5 4.37812 14.2969 4.35625 14.0375L3.61562 4H12.3844Z"
                fill="#262525"
            />
        </svg>
    );
};

export default React.memo(CENCartTrash);
